export const distanceFromBottom = element => {
  const { bottom: bottommostEdge } = element.getBoundingClientRect();
  const viewportHeight = global.innerHeight;

  return viewportHeight - bottommostEdge;
};

export const distanceFromLeft = element => {
  const { left: leftmostEdge } = element.getBoundingClientRect();

  return leftmostEdge;
};

export const distanceFromRight = element => {
  const { right: rightmostEdge } = element.getBoundingClientRect();
  const viewportWidth = global.innerWidth;

  return viewportWidth - rightmostEdge;
};

export const distanceFromTop = element => {
  const { top: topmostEdge } = element.getBoundingClientRect();

  return topmostEdge;
};
